import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { GET_REPORT_SUBMISSIONSS_FOR_PENDING_APPROVALS } from 'gql/pendingApprovals';
import { ProTable, Link, DateDisplay } from '../../layout';
import { getSelectedForTableSearch } from 'utils';
import { ENUM_REPORT_TYPE } from 'constants/form';

const defaultPageSize = 20;
const url = (item) =>
  `/projects/${item.project.id}/report-submissions/${item.id}`;
const getSelectedReportSubmissionStatus = getSelectedForTableSearch([
  'REVIEWING',
  'SCHEDULED',
  'COMPLETED',
]);
const getSelectedReportType = getSelectedForTableSearch([
  'PROGRESS_REPORT',
  'COMPLETION_REPORT',
]);
const columns = [
  {
    title: 'Project Code',
    dataIndex: ['project', 'profile', 'projectCode'],
    search: false,
    render: (_, item) => <Link to={url(item)}>{_}</Link>,
  },
  {
    title: 'Project Title',
    dataIndex: ['project', 'title'],
    search: false,
    render: (_, item) => <Link to={url(item)}>{_}</Link>,
  },
  {
    title: 'Project Code / Title',
    key: 'keyword',
    hideInTable: true,
    dataIndex: 'keyword',
  },
  {
    title: 'Report Type',
    dataIndex: 'reportType',
    initialValue: 'ALL',
    valueEnum: {
      ALL: { text: 'All' },
      PROGRESS_REPORT: { text: ENUM_REPORT_TYPE.PROGRESS_REPORT },
      COMPLETION_REPORT: { text: ENUM_REPORT_TYPE.COMPLETION_REPORT },
    },
    render: (_, item) => <Link to={url(item)}>{_}</Link>,
  },
  {
    title: 'Reporting Period',
    dataIndex: 'reportingPeriod',
    search: false,
    render: (_, item) => <Link to={url(item)}>{_}</Link>,
  },
  {
    title: 'Actual Submission Date',
    dataIndex: 'actualSubmissionDate',
    search: false,
    render: (_, item) => (
      <Link to={url(item)}>
        <DateDisplay date={item.actualSubmissionDate} />
      </Link>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    valueType: 'select',
    initialValue: 'REVIEWING',
    valueEnum: {
      ALL: { text: 'All', status: 'Default' },
      SCHEDULED: { text: 'Scheduled', status: 'Default' },
      REVIEWING: { text: 'Reviewing', status: 'Processing' },
      COMPLETED: { text: 'Completed', status: 'Success' },
    },
    render: (_, item) => <Link to={url(item)}>{_}</Link>,
  },
  {
    title: 'Remarks',
    dataIndex: 'remarks',
    search: false,
    ellipsis: true,
    render: (_, item) => <Link to={url(item)}>{_}</Link>,
  },
  /*
  {
    title: 'Project Status',
    key: 'projectStatus',
    dataIndex: ['project', 'projectStatus', 'name'],
    valueType: 'select',
    hideInTable: true,
    initialValue: 'IN_PROGRESS',
    valueEnum: {
      ALL: { text: 'All' },
      [ENUM_PROJECT_STATUS_CONTROL_TYPE.IN_PROGRESS]: { text: 'In Progress' },
      [ENUM_PROJECT_STATUS_CONTROL_TYPE.COMPLETED]: { text: 'Completed' },
      [ENUM_PROJECT_STATUS_CONTROL_TYPE.WITHDRAWN]: { text: 'Withdrawn' },
      [ENUM_PROJECT_STATUS_CONTROL_TYPE.TERMINATED]: { text: 'Terminated' },
    },
  },
  */
];

const PendingReportSubmissionsTable = () => {
  const { refetch } = useQuery(GET_REPORT_SUBMISSIONSS_FOR_PENDING_APPROVALS, {
    variables: {
      ignoreNotAuthorised: true,
      reportSubmissionStatus: ['REVIEWING'],
      reportType: ['PROGRESS_REPORT', 'COMPLETION_REPORT'],
      projectStatus: [],
      pageSize: 1,
      current: 1,
    },
    errorPolicy: 'all',
  });
  const [activeKey, setActiveKey] = useState('mine');

  return (
    <ProTable
      params={{
        activeKey,
      }}
      toolbar={{
        menu: {
          type: 'inline',
          activeKey,
          items: [
            {
              key: 'mine',
              label: <span>Need your approval</span>,
            },
            {
              key: 'all',
              label: <span>All</span>,
            },
          ],
          onChange: (key) => {
            setActiveKey(key);
          },
        },
        settings: false,
      }}
      columns={columns}
      request={async (params) => {
        const { current, pageSize, keyword, status, reportType, activeKey } =
          params;
        const result = await refetch({
          reportSubmissionStatus: getSelectedReportSubmissionStatus(status),
          reportType: getSelectedReportType(reportType),
          current,
          pageSize,
          needMyApproval: activeKey === 'mine',
          keyword,
        });
        const dataSource = result?.data?.reportSubmissionConnection?.nodes;
        return Promise.resolve({
          data: dataSource,
          success: true,
          total: result?.data?.reportSubmissionConnection?.totalCount,
        });
      }}
      rowKey="id"
      search={{
        searchText: 'Search',
        layout: 'vertical',
      }}
      pagination={{
        defaultPageSize,
        showLessItems: true,
      }}
      dateFormatter="string"
    />
  );
};
PendingReportSubmissionsTable.defaultProps = {
  data: [],
  loading: true,
};

PendingReportSubmissionsTable.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default PendingReportSubmissionsTable;
